import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const GridList = styled(Grid)`
  justify-content: space-between;
`;
